import './dashboard.css'
import CountUp from 'react-countup';
import React, {useEffect, useState} from "react";
import {Button, Modal, Space, Statistic, Typography} from "antd";
import {DashboardTile} from "./DashboardTitle";
import {ControlOutlined, InfoCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import {DashboardBuildingEmission} from "./DashboardBuildingEmission";
import {DashboardDeckGL} from "./DashboardDeckGL";
import {LoadingTail} from "../core/LoadingTail";
import {DashboardTransportEmissions} from "./DashboardTransportEmissions";
import {DashboardVegetationSequestration} from "./DashboardVegetationSequestration";
import {getDashboardData} from "./dashboardService";
import {DashbboardHelp1} from "./DashboardHelp1";
import {DashbboardHelp2} from "./DashboardHelp2";
import {DashbboardHelp3} from "./DashboardHelp3";
import {DashbboardHelp10} from "./DashboardHelp10";
import {DashbboardHelp11} from "./DashboardHelp11";
import {DashbboardHelp12} from "./DashboardHelp12";

const {Text} = Typography;

export function Dashboard() {
    const [region, setRegion] = useState("")
    const [data, setData] = useState([])
    const [dataSelected, setDataSelected] = useState({})
    const [scenario, setScenario] = useState('default')
    const [isOpenBuildingEmissions, setIsOpenBuildingEmissions] = useState(false)
    const [isOpenTransportEmissions, setIsOpenTransportEmissions] = useState(false)
    const [isOpenVegetationSequestration, setIsOpenVegetationSequestration] = useState(false)
    const [emMainBuilding, setEmMainBuilding] = useState(0)
    const [emMainTrasport, setEmMainTrasport] = useState(0)
    const [emMainVegetation, setEmMainVegetation] = useState(0)
    const [emTotal, setEmTotal] = useState(0)
    const [errorBuildingEmissions, setErrorBuildingEmissions] = useState(false)
    const [errorTransportEmissions, setErrorTransportEmissions] = useState(false)
    const [errorVegetationSequestration, setErrorVegetationSequestration] = useState(false)
    const [floorspaceTotal, setFloorspaceTotal] = useState(0)
    const formatter = (value) => <CountUp end={value} separator=" " decimals={3}/>;
    const styleTitle = {fontSize: '29px', color: '#5256BE', fontWeight: 400}

    function changeScenario(scenario) {
        switch (scenario) {
            case 'scenario_1':
                setScenario('scenario_1')
                break
            case 'scenario_2':
                setScenario('scenario_2')
                break
            case 'scenario_3':
                setScenario('scenario_3')
                break
            default:
                setScenario('default')
        }
    }

    function openSettings(type) {
        switch (type) {
            case 'buildingEmissions':
                setIsOpenBuildingEmissions(!isOpenBuildingEmissions)
                setIsOpenTransportEmissions(false)
                setIsOpenVegetationSequestration(false)
                break
            case 'transportEmissions':
                setIsOpenBuildingEmissions(false)
                setIsOpenTransportEmissions(!isOpenTransportEmissions)
                setIsOpenVegetationSequestration(false)
                break
            case 'vegetationSequestration':
                setIsOpenBuildingEmissions(false)
                setIsOpenTransportEmissions(false)
                setIsOpenVegetationSequestration(!isOpenVegetationSequestration)
                break
            default:
                setIsOpenBuildingEmissions(false)
                setIsOpenTransportEmissions(false)
                setIsOpenVegetationSequestration(false)
        }
    }

    function findData(region, scenario) {
        const result = data.filter((item) => item.region === region && item.scenario === scenario)
        return result[0]
    }

    function infoClick(id, event) {
        event.stopPropagation();

        switch (id) {
            case 0:
                Modal.info({
                    width: 1000,
                    title: <span
                        style={styleTitle}>Building  emissions</span>,
                    content: <DashbboardHelp1/>,
                    onOk() {
                    },
                })
                break
            case 1:
                Modal.info({
                    width: 1000,
                    title: <span style={styleTitle}>Transport emission</span>,
                    content: <DashbboardHelp2/>,
                    onOk() {
                    },
                })
                break
            case 2:
                Modal.info({
                    width: 1000,
                    title: <span
                        style={styleTitle}>Vegetation and other land cover-driven CO2 sequestration</span>,
                    content: <DashbboardHelp3/>,
                    onOk() {
                    },
                })
                break

            case 10:
                Modal.info({
                    width: 1000,
                    title: <span style={styleTitle}>Green Urban Growth</span>,
                    content: <DashbboardHelp10/>,
                    onOk() {
                    },
                })
                break
            case 11:
                Modal.info({
                    width: 1000,
                    title: <span style={styleTitle}>Slow-Growth Lifestyle</span>,
                    content: <DashbboardHelp11/>,
                    onOk() {
                    },
                })
                break
            case 12:
                Modal.info({
                    width: 1000,
                    title: <span style={styleTitle}>Efficient and Green Mobility</span>,
                    content: <DashbboardHelp12/>,
                    onOk() {
                    },
                })
                break
        }

    }

    useEffect(() => {

        getDashboardData().then((response) => {
            setData(response.data)
        });

    }, [])


    useEffect(() => {

        if (region !== "") {
            // setDataSelected(findData(region, 'default'))
            setDataSelected(findData(region, scenario))
        }

    }, [region, scenario])


    useEffect(() => {

        setEmTotal(emMainBuilding + emMainTrasport - emMainVegetation)

    }, [emMainBuilding, emMainTrasport, emMainVegetation])

    return (
        <>
            <DashboardDeckGL
                region={region}
                setRegion={setRegion}
            />

            {(isOpenBuildingEmissions
                || isOpenTransportEmissions
                || isOpenVegetationSequestration) && <div className="dashboardOverPanel"></div>}

            {region === "" && <div className="introDashboard">
                <Space>
                    <QuestionCircleOutlined/>
                    <Text type="secondary">Select a region on the map</Text>
                </Space>
            </div>}

            {region !== "" && <div className="menuDashboardContainer">
                <div className="menuDashboardBox menuDashboardBoxLink"
                     onClick={() => openSettings('buildingEmissions')}
                     style={{
                         borderColor: isOpenBuildingEmissions
                             ? 'var(--color-yellow)'
                             : errorBuildingEmissions ? 'red' : '#ffffff9c'
                     }}>
                    <div className="menuDashboardTitleInfo"
                         onClick={(e) => infoClick(0, e)}><InfoCircleOutlined/></div>
                    <div className="menuDashboardTitle">Building Emissions</div>
                    <div className="menuDashboardBody">
                        <div className="menuDashboardBodySettings">
                            <Text type="secondary" style={{fontSize: '0.9em'}}>MtCO2e/year</Text>
                            <ControlOutlined/>
                        </div>
                        <Statistic value={emMainBuilding} formatter={formatter}/>
                    </div>
                </div>
                <div className="menuDashboardBox menuDashboardBoxLink"
                     onClick={() => openSettings('transportEmissions')}
                     style={{
                         borderColor: isOpenTransportEmissions
                             ? 'var(--color-yellow)'
                             : errorTransportEmissions ? 'red' : '#ffffff9c'
                     }}>
                    <div className="menuDashboardTitleInfo"
                         onClick={(e) => infoClick(1, e)}><InfoCircleOutlined/></div>
                    <div className="menuDashboardTitle">Transport Emissions</div>
                    <div className="menuDashboardBody">
                        <div className="menuDashboardBodySettings">
                            <Text type="secondary" style={{fontSize: '0.9em'}}>MtCO2e/year</Text>
                            <ControlOutlined/>
                        </div>
                        <Statistic value={emMainTrasport} formatter={formatter}/>
                    </div>
                </div>
                <div className="menuDashboardBox menuDashboardBoxLink"
                     onClick={() => openSettings('vegetationSequestration')}
                     style={{
                         borderColor: isOpenVegetationSequestration
                             ? 'var(--color-yellow)'
                             : errorVegetationSequestration ? 'red' : '#ffffff9c'
                     }}>
                    <div className="menuDashboardTitleInfo"
                         onClick={(e) => infoClick(2, e)}><InfoCircleOutlined/></div>
                    <div className="menuDashboardTitle">Vegetation Sequestration</div>
                    <div className="menuDashboardBody">
                        <div className="menuDashboardBodySettings">
                            <Text type="secondary" style={{fontSize: '0.9em'}}>MtCO2e/year</Text>
                            <ControlOutlined/>
                        </div>
                        <Statistic value={emMainVegetation} formatter={formatter}/>
                    </div>
                </div>
                <div className="menuDashboardBox">
                    <div className="menuDashboardTitle">Total CO2 Budget</div>
                    <div className="menuDashboardBody">
                        <Text type="secondary" style={{fontSize: '0.9em'}}>MtCO2e/year</Text>
                        <Statistic className={emTotal > 0 ? 'statisticRed' : 'statisticGreen'}
                                   value={emTotal}
                                   formatter={formatter}/>
                    </div>
                </div>

                <div style={{
                    flex: 1
                }}></div>

                <div className="menuDashboardBox menuDashboardBoxScenario">
                    <div className="menuDashboardTitleInfo"></div>
                    <div className="menuDashboardTitle menuDashboardScenario">Policy Scenarios</div>
                    <div className="menuDashboardBody menuDashboardBodyScenario">
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 10
                        }}>
                            <Button type="primary" size="small"
                                    ghost={scenario !== 'scenario_1'}
                                    style={{flex: 1}}
                                    onClick={() => changeScenario('scenario_1')}>
                                Green Urban Growth
                            </Button>
                            <div style={{width: 10}}></div>
                            <div onClick={(e) => infoClick(10, e)}
                                 className="menuDashboardBoxScenarioInfo"><InfoCircleOutlined/></div>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 10
                        }}>
                            <Button type="primary" size="small"
                                    ghost={scenario !== 'scenario_2'}
                                    style={{flex: 1}}
                                    onClick={() => changeScenario('scenario_2')}>
                                Slow-Growth Lifestyle
                            </Button>
                            <div style={{width: 10}}></div>
                            <div onClick={(e) => infoClick(11, e)}
                                 className="menuDashboardBoxScenarioInfo"><InfoCircleOutlined/></div>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 10
                        }}>
                            <Button type="primary" size="small"
                                    ghost={scenario !== 'scenario_3'}
                                    style={{flex: 1}}
                                    onClick={() => changeScenario('scenario_3')}>
                                Efficient and Green Mobility
                            </Button>
                            <div style={{width: 10}}></div>
                            <div onClick={(e) => infoClick(12, e)}
                                 className="menuDashboardBoxScenarioInfo"><InfoCircleOutlined/></div>
                        </div>


                    </div>
                </div>

                <Button type="default" size="small"
                        onClick={() => changeScenario('default')}>
                    Back to default
                </Button>
            </div>}

            <DashboardBuildingEmission
                isOpenBuildingEmissions={isOpenBuildingEmissions}
                setIsOpenBuildingEmissions={setIsOpenBuildingEmissions}
                setEmMainBuilding={setEmMainBuilding}
                data={dataSelected}
                setFloorspaceTotal={setFloorspaceTotal}
                setErrorBuildingEmissions={setErrorBuildingEmissions}
            />

            <DashboardTransportEmissions
                isOpenTransportEmissions={isOpenTransportEmissions}
                setIsOpenTransportEmissions={setIsOpenTransportEmissions}
                setEmMainTrasport={setEmMainTrasport}
                data={dataSelected}
                setErrorTransportEmissions={setErrorTransportEmissions}
            />

            <DashboardVegetationSequestration
                isOpenVegetationSequestration={isOpenVegetationSequestration}
                setIsOpenVegetationSequestration={setIsOpenVegetationSequestration}
                setEmMainVegetation={setEmMainVegetation}
                data={dataSelected}
                floorspaceTotal={floorspaceTotal}
                setErrorVegetationSequestration={setErrorVegetationSequestration}
            />

            <DashboardTile region={region}/>

            <LoadingTail/>
        </>

    )
}